import styles from "components/DimensionSpinner/DimensionSpinner.module.css";

export default function DimensionSpinner({ style = {} }) {
    // The style prop allows using inline style where rendered to override the default style
    return (
        <div
            style={style}
            className={styles.dimensionSpinner}
            data-testid="dimensionSpinner"
        />
    );
}
